module.exports = __webpack_public_path__ + "img/zhinengmingpian.5cfc8b61.png";